module.exports = __webpack_public_path__ + "static/ACP-Logo-d62873419af97547ac941bec736936b8.png";